import { PromptType, TextPrompt } from 'jobs/prompts/prompt-types'
import { noop } from 'lodash'
import { IPromptInputEditorViewModel } from '../IPromptInputEditorViewModel'

/**
 * View Model for a Text Prompt Input type.
 */
export class TextPromptInputEditorViewModel
  implements IPromptInputEditorViewModel
{
  /**
   * Maps this View Model to a Text Prompt Input Type.
   */
  toInput(): TextPrompt {
    return {
      type: PromptType.Text,
    }
  }

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return true
  }

  /**
   * @inheritdoc
   */
  reset = noop
}
